import {initPreviewFor} from "../utils/WebPreview.ts";

(function($) {
	var defaults = { 
			title: 'Activity timeline',
			more: 'Show more',
			empty: 'No notifications yet',
			sens: true
	};

	$.fn.bonz = function(options) {
		// method calling
		if (typeof options == 'string') {
			var args = Array.prototype.slice.call(arguments, 1);
			var res = undefined;
			this.each(function() {
				var bnz = $.data(this, 'bonz');
				if (bnz && $.isFunction(bnz[options])) {
					var r = bnz[options].apply(bnz, args);
					if (res === undefined) { res = r; }
					if (options == 'destroy') { $.removeData(this, 'bonz'); }
				}
			});
			if (res !== undefined) {
				return res;
			}
			return this;
		}
		options = options || {};
		
		options = $.extend(true, {}, defaults, options);
			
		this.each(function(i, _element) {
			var element = $(_element);
			var bnz = new Bonz(element, options);
			element.data('bonz', bnz);
			bnz.render();
		});
		return this;
	};
	
}(jQuery));


function Bonz(element, options) {
	this.options = options;
	this.render = renderBonz;
	var root = $("<div class='bz-widget'></div>");
	element.append(root);
	var headerElement = $("<div class='bz-header'></div>");
	var contentElement = $("<div class='bz-container'></div>");
	var moreElement = $("<div class='bz-more'></div>");

	root.append(headerElement);
	root.append(contentElement);
	var	moreLink = $("<a href='#'>"+options.more+"</a>");
	moreLink.click(function(evt) { loadMore(); evt.preventDefault(); });
	moreElement.append(moreLink);
	root.append(moreElement);
	// Locals
	var content;
	
	function renderBonz() {
		if (!content) initialRender();
	}
	
	var timelineUpdater;
	
	function initialRender() {
		createHeader();
		loadTimeline();
		timelineUpdater = window.setInterval(updateTimeline, 60019);
	}
	
	function updateTimeline() {
		if (content && content.toId!=0) {
			jQuery.ajax('bonzFeed.do?action=load&recent=true&from='+(content.toId<0 ? 0 : content.toId)).done(function(data) {
				if (typeof data === 'string') {
					console.log(data); // error from the server
					return;
				}
				if (content == null) content = data;
				else {
					content.items = data.items.concat(content.items);
					content.fromId = Math.min(content.fromId, data.fromId);
					content.toId = Math.max(content.toId, data.toId);
				}
				prependContent(data);
				updateDates();
			})
			.fail(function(data) { /* silent fail */ });
		}
	}
	
	function loadMore() {
		if (content && content.fromId>0) {
			jQuery.ajax('bonzFeed.do?action=load&recent=false&to='+content.fromId).done(function(data) {
				if (content == null) content = data;
				else {
					content.items = content.items.concat(data.items);
					content.fromId = Math.min(content.fromId, data.fromId);
					content.toId = Math.max(content.toId, data.toId);
				}
				appendContent(data);
			})
			.fail(function(data) {console.log('Cannot load timeline')});
		}
	}
	
	function createHeader() {
		headerElement.append("<div class='bz-title'>"+options.title+"</div>");
	}
	
	function loadTimeline()
	{
		jQuery.ajax('bonzFeed.do?action=load&recent=true').done(function(data) {
			content = data;	// save the data
			renderContent();
		})
		.fail(function(data) {console.log('Cannot load timeline')});
	}
	
	function prependContent(newItems) {
		var dur = 400;
		if (newItems.items.length > 0) {
			for (var i = newItems.items.length-1; i >= 0; i--) {
				var	itemHtml = createItem(newItems.items[i]);
				itemHtml.hide();
				contentElement.prepend(itemHtml);
				itemHtml.fadeIn(dur);
				dur += 100;
			}
			$('.bz-empty').hide();
			$('.bz-more').show();
		}
	}
	
	function appendContent(newItems) {
		var dur = 400;
		if (newItems.items.length > 0) {
			for (var i = 0; i < newItems.items.length; i++) {
				var	itemHtml = createItem(newItems.items[i]);
				itemHtml.hide();
				contentElement.append(itemHtml);
				itemHtml.fadeIn(dur);
				dur += 100;
			}
			$('.bz-empty').hide();
		}
	}
	
	function renderContent() {
		contentElement.empty();	// empty old content
		if (content) {
			if (content.items.length > 0) {
				for (var i = 0; i < content.items.length; i++) {
					var	listHtml = createItem(content.items[i]);
					contentElement.append(listHtml);
				}
			} else {
				var emptyHtml = $("<div class='bz-empty'>"+options.empty+"</div>");
				contentElement.append(emptyHtml);
				$('.bz-more').hide();
			}
		}
	}
	
	function createItem(itemObject) {
		var	itemDiv = $("<div class='bz-item tl-color"+itemObject.color+"'></div>");
		itemDiv.data('id', itemObject.id);
		var	avDiv = $("<div class='bz-avatar'></div>");
		var	itemContentDiv = $("<div class='bz-icontent'></div>");
		$('<img src="avatar/'+itemObject.user+'" class="avatar">').appendTo(avDiv);
		var	nameDiv = $("<div class='bz-name'></div>");
		var	dateDiv = $("<div class='bz-date'></div>");
		var	htmlDiv = $("<div class='bz-html'></div>");
		nameDiv.html(itemObject.userName);
		dateDiv.html(smartDate(new Date(parseInt(itemObject.when)), false));
		dateDiv.data('ms', itemObject.when);
		htmlDiv.html(itemObject.html);
		if (!options.sens) htmlDiv.find('.bz-sensitive').remove();
		itemContentDiv.append(dateDiv);
		itemContentDiv.append(nameDiv);
		itemContentDiv.append(htmlDiv);
		itemDiv.append(avDiv);
		itemDiv.append(itemContentDiv);
		// init preview
		itemDiv.find("a").each(function() { initPreviewFor($(this)); });
		return itemDiv;
	}
	
	function updateDates() {
		$('.bz-date').each(function() {
			var ms = $(this).data('ms');
			$(this).html(smartDate(new Date(parseInt(ms)), false));
		});
	}
}